import { Modal, ModalOverlay, Dialog as RADialog } from "react-aria-components";
import { usePlosTranslations } from "../../contexts/PlosTranslationsContext";
import CloseIcon from "../../img/icons/cross.svg?react";
import { modalOverlay } from "../../styles/utils.css";
import { IconButton } from "../buttons/IconButton";
import {
  dialogContent,
  dialogContentWrapperStyles,
  headerStyles,
} from "./dialog.css";
import { DialogProps } from "./types";

const Dialog = ({
  children,
  handleClose,
  handleOpen,
  label,
  isOpen,
  trigger,
  headerVariant = "standard",
}: DialogProps) => {
  const { dialog: defaults } = usePlosTranslations();
  return (
    <>
      {trigger && handleOpen && trigger({ onClick: handleOpen })}
      <ModalOverlay
        isOpen={isOpen}
        onOpenChange={handleClose}
        className={modalOverlay}
        isDismissable
      >
        <Modal>
          <RADialog aria-label={label} className={dialogContentWrapperStyles}>
            <header className={headerStyles[headerVariant]}>
              <IconButton
                onPress={handleClose}
                icon={<CloseIcon aria-label={defaults.closeButton} />}
                appearance={headerVariant === "gradient" ? "glass" : "outlined"}
                label={defaults.closeButton}
              />
            </header>
            <div className={dialogContent}>{children}</div>
          </RADialog>
        </Modal>
      </ModalOverlay>
    </>
  );
};

export default Dialog;
